import React, { useContext } from 'react'
import { appContext } from '../App'

const ChatDateMarker = ({ message }) => {
  const { day: thisDay, month: thisMonth, year: thisYear } = useContext(appContext)
  
  const { id, year, month, day } = message


  return (
    <div id={id} className='chat-date-marker'>
      <p>
        {thisYear === year && thisMonth === month && thisDay === day ?
          <>Today</>

        : thisYear === year && thisMonth === month && thisDay === (day + 1) ?
          <>Yesterday</>

        :
          <>
            {day}/{month}/{year}
          </>
        }
      </p>
    </div>
  )
}

export default ChatDateMarker